import { initializeSdk } from '@eventbrite/statsig';

export const initializeStatsigSdk = async (userProps: {
    isAuthenticated: boolean;
    publicId: string;
}) => {
    await initializeSdk({
        user: {
            userID: userProps.publicId,
        },
    });
};
